import { Image, VideoPlayer, VideoPlayerExternal } from '@/components/Core'
import { ImageProps } from '@/components/Core/Image'
import { MediaBlockFragment } from '@/lib/fragments'
import { Lib } from '@/types'
import { MEDIA } from '@config'
import clsx from 'clsx'
import { readFragment } from 'gql.tada'
import dynamic from 'next/dynamic'
import { memo } from 'react'

const BackgroundVideo = dynamic(() => import('next-video/background-video'), {
  ssr: false
})

export interface MediaProps {
  data: Lib.FragmentOf<typeof MediaBlockFragment>
  className?: string
  ar?: ImageProps['ar'] | undefined
}

const Media = ({ data, ar, className }: MediaProps) => {
  const d = readFragment(MediaBlockFragment, data)

  return (
    <>
      {d?.mediaType === 'video_external' ||
      d?.mediaType === 'video' ||
      d?.mediaType === 'video_background' ? (
        <div className={clsx('relative')}>
          {d?.mediaType === 'video_background' ? (
            <BackgroundVideo
              playbackId={d.video?.video.muxPlaybackId}
              className={
                'h-full w-full overflow-hidden rounded-md object-cover'
              }
              autoPlay
              loop
              muted
            />
          ) : (
            <>
              {d?.mediaType === 'video_external' ? (
                <VideoPlayerExternal
                  data={d.videoExternal}
                  className={clsx(
                    'aspect-video !h-auto !w-full overflow-hidden rounded-md',
                    className
                  )}
                />
              ) : (
                <VideoPlayer
                  data={d.video}
                  className={clsx(className, 'overflow-hidden rounded-md')}
                />
              )}
            </>
          )}
        </div>
      ) : (
        <Image
          data={d.image}
          imgClassName={clsx('rounded-md overflow-hidden', className)}
          ar={ar}
          fitWrap
          sizes={`${MEDIA.sm}  100vw, 86rem`}
        />
      )}
    </>
  )
}

export default memo(Media)
